<div class="speech-box" [ngClass]="{'speech-box-user': chatEntity.author === author.user, 'speech-box-eva': chatEntity.author === author.eva}">
    <div style="margin-bottom:0.5rem;" [innerHtml]="chatEntity.text | safeHtml"></div>
    <button mat-raised-button color="primary" (click)="doRedirect()">{{ data.buttonText }}</button>
    <div class="speech-box-originator" *ngIf="chatEntity.originator">From {{ chatEntity.originator }}</div>
</div>